import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import { CompanyOperatingSegmentsTabEnum } from "components/company/v3/menu/enums";
import OperatingSegments from "components/stocks/modern/OperatingSegments/OperatingSegments";
import OperatingSegmentsDataProvider from "components/stocks/modern/OperatingSegments/OperatingSegmentsDataProvider";
import { Tabs } from "components/ui/Tabs";
import { Provider } from "jotai";
import { GlobeIcon, PieChartIcon } from "lucide-react";
import { ErrorBoundary } from "react-error-boundary";
import { useIntl } from "react-intl";

interface AmericanOperatingSegmentsBoxProps {
  tickerSymbol: string;
  tab: CompanyOperatingSegmentsTabEnum;
  onChangeTab: (tab: CompanyOperatingSegmentsTabEnum) => void;
}

export default function AmericanOperatingSegmentsBox({
  tickerSymbol,
  tab,
  onChangeTab,
}: AmericanOperatingSegmentsBoxProps) {
  const intl = useIntl();

  return (
    <CompanyContainer className="xl:h-full xl:min-h-[553px]">
      <CompanyContentContainer className="grow">
        <Tabs
          defaultValue={CompanyOperatingSegmentsTabEnum.BUSINESS}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyOperatingSegmentsTabEnum)}
          className="h-full w-full xl:h-auto"
        >
          <CompanyTabsList
            activeTab={tab}
            tabs={[
              {
                value: CompanyOperatingSegmentsTabEnum.BUSINESS,
                label: intl.formatMessage({
                  defaultMessage: "Receitas",
                  description: "Aba do menu superior da empresa",
                  id: "QMMBPJ",
                }),
                icon: <PieChartIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
              {
                value: CompanyOperatingSegmentsTabEnum.GEOGRAPHIC,
                label: intl.formatMessage({
                  defaultMessage: "Países",
                  description: "Aba do menu superior da empresa",
                  id: "d7X3Af",
                }),
                icon: <GlobeIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ]}
          />

          <CompanyTabsContent value={CompanyOperatingSegmentsTabEnum.BUSINESS}>
            <OperatingSegmentsDataProvider tickerSymbols={[tickerSymbol]}>
              {({ businessSegments }) => {
                if (businessSegments) {
                  return (
                    <ErrorBoundary fallbackRender={() => null}>
                      <Provider>
                        <OperatingSegments
                          kind="BUSINESS"
                          tickerSymbols={[tickerSymbol]}
                          financialSegments={businessSegments}
                        />
                      </Provider>
                    </ErrorBoundary>
                  );
                }
                return null;
              }}
            </OperatingSegmentsDataProvider>
          </CompanyTabsContent>

          <CompanyTabsContent value={CompanyOperatingSegmentsTabEnum.GEOGRAPHIC}>
            <OperatingSegmentsDataProvider tickerSymbols={[tickerSymbol]}>
              {({ geographicSegments }) => {
                if (geographicSegments) {
                  return (
                    <ErrorBoundary fallbackRender={() => null}>
                      <Provider>
                        <OperatingSegments
                          kind="GEOGRAPHIC"
                          tickerSymbols={[tickerSymbol]}
                          financialSegments={geographicSegments}
                        />
                      </Provider>
                    </ErrorBoundary>
                  );
                }
                return null;
              }}
            </OperatingSegmentsDataProvider>
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
